import { createContext, useContext, useState, type ReactNode } from 'react';

interface DocsSessionValue {
  apiKey: string;
  setApiKey: (value: string) => void;
}
const DocsSession = createContext<DocsSessionValue>({ apiKey: '', setApiKey: () => {} });
interface Props {
  children: ReactNode;
}

export default function DocsSessionProvider({ children }: Props) {
  const [apiKey, setApiKey] = useState('');
  return <DocsSession.Provider value={{ apiKey, setApiKey }}>{children}</DocsSession.Provider>;
}

export const useDocsSession = () => useContext(DocsSession);
